webpackJsonp([159014900043430],{

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NEDesignSystemHero.a85e83ac.jpg";

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cloud-cost-management-hero.5ee32991.png";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hazel.2f1edff7.jpg";

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/instance-explorer.6567c9ba.jpg";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/new-engen-lift.377722ad.jpeg";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nginx.90ad15ca.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _jsCookie = __webpack_require__(46);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _Hero = __webpack_require__(11);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _WorkItem = __webpack_require__(13);
	
	var _WorkItem2 = _interopRequireDefault(_WorkItem);
	
	var _constants = __webpack_require__(37);
	
	var _nginx = __webpack_require__(414);
	
	var _nginx2 = _interopRequireDefault(_nginx);
	
	var _NEDesignSystemHero = __webpack_require__(62);
	
	var _NEDesignSystemHero2 = _interopRequireDefault(_NEDesignSystemHero);
	
	var _hazel = __webpack_require__(64);
	
	var _hazel2 = _interopRequireDefault(_hazel);
	
	var _newEngenLift = __webpack_require__(413);
	
	var _newEngenLift2 = _interopRequireDefault(_newEngenLift);
	
	var _instanceExplorer = __webpack_require__(65);
	
	var _instanceExplorer2 = _interopRequireDefault(_instanceExplorer);
	
	var _cloudCostManagementHero = __webpack_require__(63);
	
	var _cloudCostManagementHero2 = _interopRequireDefault(_cloudCostManagementHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PastWork = function (_React$Component) {
	  _inherits(PastWork, _React$Component);
	
	  function PastWork() {
	    _classCallCheck(this, PastWork);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PastWork.prototype.componentDidMount = function componentDidMount() {
	    _jsCookie2.default.set(_constants.PATH_PREFIX_COOKIE, '');
	  };
	
	  PastWork.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Work | matt harris' }),
	      _react2.default.createElement(
	        _Hero2.default,
	        { title: 'Work', customClassName: 'mb-4' },
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          'A collection of projects and design work'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'container mb-5 pb-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row mb-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mb-4 mb-md-0' },
	            _react2.default.createElement(_WorkItem2.default, { href: 'https://www.datadoghq.com/product/cloud-cost-management/', title: 'Cloud Cost Management', image: _cloudCostManagementHero2.default })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mb-4 mb-md-0' },
	            _react2.default.createElement(_WorkItem2.default, { href: 'https://instances.datadoghq.com/', title: 'Instance Explorer', image: _instanceExplorer2.default })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row mb-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mb-4 mb-md-0' },
	            _react2.default.createElement(_WorkItem2.default, { href: 'https://www.nginx.com/', title: 'NGINX', image: _nginx2.default })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mb-4 mb-md-0' },
	            _react2.default.createElement(_WorkItem2.default, { href: 'https://newengen.com/technology/', title: 'New Engen', subtitle: 'LIFT Platform', image: _newEngenLift2.default })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row mb-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8' },
	            _react2.default.createElement(_WorkItem2.default, {
	              link: '/new-engen-design-system/',
	              title: 'New Engen Design System',
	              image: _NEDesignSystemHero2.default
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(_WorkItem2.default, {
	              link: '/hazel/',
	              title: 'Hazel Analytics',
	              subtitle: 'Web app redesign',
	              image: _hazel2.default
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return PastWork;
	}(_react2.default.Component);
	
	exports.default = PastWork;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-past-work-js-90457766a2b37ef6c075.js